// ProfitReport.jsx
// import React, { useState, useEffect } from 'react';
// import { getAllBusesIncome, getBusIncome, getBusIncomeSummary } from '../../Services/Operations/ProductAPI';
// import '../../Styles/ManagementPages.css';
// import { useSelector } from 'react-redux';

// const ProfitReport = () => {
//   const [profitData, setProfitData] = useState([]);
//   const [summary, setSummary] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [searching, setSearching] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewingBus, setViewingBus] = useState(null);
//   const [error, setError] = useState(null);
//   const { token } = useSelector(state => state.user);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalItems, setTotalItems] = useState(0);
//   const [pageSize] = useState(10);

//   // Filter states
//   const [filters, setFilters] = useState({
//     startDate: '',
//     endDate: '',
//     busType: '',
//     busCategory: '',
//     ownerId: '',
//     minEarnings: '',
//     maxEarnings: ''
//   });
//   const [showFilters, setShowFilters] = useState(false);
//   const [isFiltered, setIsFiltered] = useState(false);
  
//   // Sorting states
//   const [sortBy, setSortBy] = useState('totalEarnings');
//   const [sortOrder, setSortOrder] = useState('desc');

//   // Fetch all buses profit data
//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchAllBusesProfit();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm, filters, sortBy, sortOrder]);

//   const fetchAllBusesProfit = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       setError(null);
      
//       // Prepare filter parameters
//       const filterParams = {};
      
//       if (searchTerm) {
//         filterParams.search = searchTerm;
//       }
      
//       // Add other filters
//       Object.keys(filters).forEach(key => {
//         if (filters[key] && filters[key] !== '') {
//           filterParams[key] = filters[key];
//         }
//       });

//       // Add pagination and sorting
//       const params = {
//         page: currentPage,
//         limit: pageSize,
//         sortBy: sortBy,
//         sortOrder: sortOrder,
//         ...filterParams
//       };

//       console.log('Fetching profit data with params:', params);

//       const response = await getAllBusesIncome(params, token);
      
//       if (response && response.success) {
//         console.log('Profit data response:', response);
        
//         setProfitData(response.data.buses || []);
//         setSummary(response.data.summary);
//         setTotalPages(response.data.pagination?.totalPages || 1);
//         setTotalItems(response.data.pagination?.totalItems || 0);
        
//         // Check if any filter is active
//         const hasActiveFilters = 
//           searchTerm !== '' || 
//           Object.values(filters).some(value => value && value !== '');
//         setIsFiltered(hasActiveFilters);
//       } else {
//         setError('Failed to fetch profit data.');
//         setProfitData([]);
//       }
//     } catch (err) {
//       console.error('Error fetching profit data:', err);
//       setError('Failed to fetch profit data. Please try again.');
//       setProfitData([]);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   // Fetch single bus details
//   const handleViewBusDetails = async (bus) => {
//     try {
//       setLoading(true);
//       const params = {};
      
//       if (filters.startDate) params.startDate = filters.startDate;
//       if (filters.endDate) params.endDate = filters.endDate;
      
//       const response = await getBusIncome(bus.bus.id, params, token);
      
//       if (response && response.success) {
//         setViewingBus(response.data);
//       } else {
//         alert('Failed to fetch bus details');
//       }
//     } catch (error) {
//       console.error('Error fetching bus details:', error);
//       alert('Error fetching bus details: ' + (error.response?.data?.message || error.message));
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Filter handlers
//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     setCurrentPage(1);
//     fetchAllBusesProfit();
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const applyFilters = () => {
//     setCurrentPage(1);
//     fetchAllBusesProfit();
//     setShowFilters(false);
//   };

//   const clearFilters = () => {
//     setFilters({
//       startDate: '',
//       endDate: '',
//       busType: '',
//       busCategory: '',
//       ownerId: '',
//       minEarnings: '',
//       maxEarnings: ''
//     });
//     setSearchTerm('');
//     setCurrentPage(1);
//     setIsFiltered(false);
//   };

//   // Sort handler
//   const handleSort = (field) => {
//     if (sortBy === field) {
//       setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
//     } else {
//       setSortBy(field);
//       setSortOrder('desc');
//     }
//     setCurrentPage(1);
//   };

//   // Export CSV function
//   const handleExportReport = () => {
//     if (profitData.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = [
//       'Bus Number', 
//       'Bus Name', 
//       'Bus Type', 
//       'Owner Name', 
//       'Total Bookings', 
//       'Total Seats Sold', 
//       'Total Earnings (₹)', 
//       'Commission (₹)', 
//       'Net Income (₹)',
//       'Avg Ticket Price (₹)'
//     ];
    
//     const csvData = profitData.map(item => [
//       item.bus.busNumber || '',
//       item.bus.busName || '',
//       item.bus.busType || '',
//       item.owner.name || '',
//       item.stats.totalBookings || 0,
//       item.stats.totalSeatsSold || 0,
//       item.stats.totalEarnings || 0,
//       item.stats.totalCommission || 0,
//       item.stats.netIncome || 0,
//       item.stats.averageTicketPrice || 0
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `profit-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('Profit report exported successfully!');
//   };

//   const closeViewModal = () => {
//     setViewingBus(null);
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     clearFilters();
//     fetchAllBusesProfit();
//   };

//   // Pagination handlers
//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Format currency
//   const formatCurrency = (amount) => {
//     return `₹${(amount || 0).toLocaleString()}`;
//   };

//   // Get bus type badge class
//   const getBusTypeBadge = (busType) => {
//     const type = (busType || '').toLowerCase();
//     if (type === 'ac') return 'bus-type-ac';
//     if (type === 'non-ac') return 'bus-type-non-ac';
//     return 'bus-type-standard';
//   };

//   // Generate page numbers
//   const generatePageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 5;
    
//     if (totalPages <= maxVisiblePages) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(i);
//       }
//     } else {
//       let start = Math.max(1, currentPage - 2);
//       let end = Math.min(totalPages, start + maxVisiblePages - 1);
      
//       if (end - start + 1 < maxVisiblePages) {
//         start = Math.max(1, end - maxVisiblePages + 1);
//       }
      
//       for (let i = start; i <= end; i++) {
//         pages.push(i);
//       }
//     }
    
//     return pages;
//   };

//   if (loading && profitData.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="loading-container">
//           <p>Loading profit data...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Profit Report</h1>
//         <div className="header-actions">
//           <form onSubmit={handleSearchSubmit} className="search-form">
//             <div style={{ position: 'relative' }}>
//               <input 
//                 type="text" 
//                 placeholder="Search by bus number, name or owner..." 
//                 className="search-input" 
//                 value={searchTerm}
//                 onChange={handleSearchChange}
//                 style={{ width: "70%" }}
//               />
//               {searching && (
//                 <span style={{
//                   position: 'absolute', right: '10px', top: '50%',
//                   transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//                 }}>
//                   searching...
//                 </span>
//               )}
//             </div>
//           </form>
          
//           <button className="filter-toggle-btn" onClick={() => setShowFilters(!showFilters)}>
//             {showFilters ? 'Hide Filters' : 'Show Filters'}
//           </button>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportReport}>
//             Export Report
//           </button>
//         </div>
//       </div>

//       {/* Filter Panel */}
//       {showFilters && (
//         <div className="filter-panel">
//           <div className="filter-header">
//             <h3>Filter Profit Report</h3>
//             <button className="close-filters" onClick={() => setShowFilters(false)}>
//               ×
//             </button>
//           </div>
//           <div className="filter-grid">
//             <div className="filter-group">
//               <label>Date From</label>
//               <input
//                 type="date"
//                 name="startDate"
//                 value={filters.startDate}
//                 onChange={handleFilterChange}
//               />
//             </div>
//             <div className="filter-group">
//               <label>Date To</label>
//               <input
//                 type="date"
//                 name="endDate"
//                 value={filters.endDate}
//                 onChange={handleFilterChange}
//               />
//             </div>
//             <div className="filter-group">
//               <label>Bus Type</label>
//               <select
//                 name="busType"
//                 value={filters.busType}
//                 onChange={handleFilterChange}
//               >
//                 <option value="">All Types</option>
//                 <option value="AC">AC</option>
//                 <option value="Non-AC">Non-AC</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Bus Category</label>
//               <select
//                 name="busCategory"
//                 value={filters.busCategory}
//                 onChange={handleFilterChange}
//               >
//                 <option value="">All Categories</option>
//                 <option value="sleeper">Sleeper</option>
//                 <option value="seater">Seater</option>
//                 <option value="semi-sleeper">Semi-Sleeper</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Min Earnings (₹)</label>
//               <input
//                 type="number"
//                 name="minEarnings"
//                 value={filters.minEarnings}
//                 onChange={handleFilterChange}
//                 placeholder="Minimum earnings"
//                 min="0"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Max Earnings (₹)</label>
//               <input
//                 type="number"
//                 name="maxEarnings"
//                 value={filters.maxEarnings}
//                 onChange={handleFilterChange}
//                 placeholder="Maximum earnings"
//                 min="0"
//               />
//             </div>
//           </div>
//           <div className="filter-actions">
//             <button className="apply-filters-btn" onClick={applyFilters}>
//               Apply Filters
//             </button>
//             <button className="clear-filters-btn" onClick={clearFilters}>
//               Clear All
//             </button>
//           </div>
//           {isFiltered && (
//             <div className="active-filters">
//               <span>Active Filters:</span>
//               {searchTerm && (
//                 <span className="filter-tag">Search: {searchTerm}</span>
//               )}
//               {filters.busType && (
//                 <span className="filter-tag">Type: {filters.busType}</span>
//               )}
//               {filters.busCategory && (
//                 <span className="filter-tag">Category: {filters.busCategory}</span>
//               )}
//               {filters.startDate && (
//                 <span className="filter-tag">From: {filters.startDate}</span>
//               )}
//               {filters.endDate && (
//                 <span className="filter-tag">To: {filters.endDate}</span>
//               )}
//               {filters.minEarnings && (
//                 <span className="filter-tag">Min: ₹{filters.minEarnings}</span>
//               )}
//               {filters.maxEarnings && (
//                 <span className="filter-tag">Max: ₹{filters.maxEarnings}</span>
//               )}
//             </div>
//           )}
//         </div>
//       )}

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       {/* Summary Stats Cards */}
//       {summary && (
//         <div className="stats-cards">
//           <div className="stat-card">
//             <h3>Total Earnings</h3>
//             <p>{formatCurrency(summary.totalEarnings)}</p>
//             <span>Gross revenue</span>
//           </div>
//           <div className="stat-card">
//             <h3>Total Commission</h3>
//             <p>{formatCurrency(summary.totalCommission)}</p>
//             <span>Paid to owners</span>
//           </div>
//           <div className="stat-card">
//             <h3>Net Profit</h3>
//             <p>{formatCurrency(summary.totalNetIncome)}</p>
//             <span>After commission</span>
//           </div>
//           <div className="stat-card">
//             <h3>Total Bookings</h3>
//             <p>{summary.totalBookings || 0}</p>
//             <span>Confirmed bookings</span>
//           </div>
//           <div className="stat-card">
//             <h3>Seats Sold</h3>
//             <p>{summary.totalSeatsSold || 0}</p>
//             <span>Total seats</span>
//           </div>
//         </div>
//       )}

//       {/* Profit Table */}
//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th onClick={() => handleSort('busNumber')} style={{ cursor: 'pointer' }}>
//                 Bus Number {sortBy === 'busNumber' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th onClick={() => handleSort('busName')} style={{ cursor: 'pointer' }}>
//                 Bus Name {sortBy === 'busName' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th>Bus Type</th>
//               <th onClick={() => handleSort('ownerName')} style={{ cursor: 'pointer' }}>
//                 Owner {sortBy === 'ownerName' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th onClick={() => handleSort('totalBookings')} style={{ cursor: 'pointer' }}>
//                 Bookings {sortBy === 'totalBookings' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th onClick={() => handleSort('totalSeatsSold')} style={{ cursor: 'pointer' }}>
//                 Seats Sold {sortBy === 'totalSeatsSold' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th onClick={() => handleSort('totalEarnings')} style={{ cursor: 'pointer' }}>
//                 Earnings {sortBy === 'totalEarnings' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th onClick={() => handleSort('totalCommission')} style={{ cursor: 'pointer' }}>
//                 Commission {sortBy === 'totalCommission' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th onClick={() => handleSort('netIncome')} style={{ cursor: 'pointer' }}>
//                 Net Profit {sortBy === 'netIncome' && (sortOrder === 'asc' ? '↑' : '↓')}
//               </th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {profitData.length > 0 ? (
//               profitData.map((item, index) => (
//                 <tr key={item.bus.id || index}>
//                   <td className="transaction">{item.bus.busNumber || 'N/A'}</td>
//                   <td>{item.bus.busName || 'N/A'}</td>
//                   <td>
//                     <span className={`bus-type-badge ${getBusTypeBadge(item.bus.busType)}`}>
//                       {item.bus.busType || 'Standard'}
//                     </span>
//                   </td>
//                   <td>
//                     <div>
//                       <div>{item.owner.name || 'N/A'}</div>
//                       <div className="phone">{item.owner.companyName || ''}</div>
//                     </div>
//                   </td>
//                   <td>{item.stats.totalBookings || 0}</td>
//                   <td>{item.stats.totalSeatsSold || 0}</td>
//                   <td className="earning">{formatCurrency(item.stats.totalEarnings)}</td>
//                   <td className="commission">{formatCurrency(item.stats.totalCommission)}</td>
//                   <td className="profit">{formatCurrency(item.stats.netIncome)}</td>
//                   <td>
//                     <div className="action-buttons">
//                       <button 
//                         className="action-btn view" 
//                         onClick={() => handleViewBusDetails(item)}
//                       >
//                         View Details
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="10" className="no-data">
//                   <p>No profit data found {isFiltered ? 'matching your filters' : ''}.</p>
//                   {isFiltered && (
//                     <button className="clear-filters-link" onClick={clearFilters}>
//                       Clear filters to see all data
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing {profitData.length} of {totalItems} buses
//             (Page {currentPage} of {totalPages})
//             {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//             {isFiltered && !searchTerm && <span className="filtered-indicator"> • Filtered Results</span>}
//           </div>
//           <div className="pagination-controls">
//             <button 
//               className="pagination-btn" 
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>
            
//             <div className="page-numbers">
//               {generatePageNumbers().map(pageNumber => (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               ))}
              
//               {totalPages > 5 && currentPage < totalPages - 2 && (
//                 <>
//                   <span className="page-dots">...</span>
//                   <button
//                     className="page-number"
//                     onClick={() => handlePageClick(totalPages)}
//                   >
//                     {totalPages}
//                   </button>
//                 </>
//               )}
//             </div>
            
//             <button 
//               className="pagination-btn" 
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages}
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Bus Details Modal */}
//       {viewingBus && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px' }}>
//             <div className="modal-header">
//               <h3>Bus Profit Details - {viewingBus.bus?.busNumber}</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               {/* Bus Information */}
//               <div className="detail-section">
//                 <h4>Bus Information</h4>
//                 <div className="detail-grid">
//                   <div className="detail-row">
//                     <label>Bus Number:</label>
//                     <span>{viewingBus.bus?.busNumber || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Bus Name:</label>
//                     <span>{viewingBus.bus?.busName || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Bus Type:</label>
//                     <span>{viewingBus.bus?.busType || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Total Seats:</label>
//                     <span>{viewingBus.bus?.totalSeats || 'N/A'}</span>
//                   </div>
//                 </div>
//               </div>

//               {/* Owner Information */}
//               <div className="detail-section">
//                 <h4>Owner Information</h4>
//                 <div className="detail-grid">
//                   <div className="detail-row">
//                     <label>Owner Name:</label>
//                     <span>{viewingBus.owner?.name || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Company:</label>
//                     <span>{viewingBus.owner?.companyName || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Email:</label>
//                     <span>{viewingBus.owner?.email || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Phone:</label>
//                     <span>{viewingBus.owner?.phone || 'N/A'}</span>
//                   </div>
//                   <div className="detail-row">
//                     <label>Commission Rate:</label>
//                     <span>{viewingBus.owner?.commissionRate || 10}%</span>
//                   </div>
//                 </div>
//               </div>

//               {/* Financial Summary */}
//               <div className="detail-section">
//                 <h4>Financial Summary</h4>
//                 <div className="financial-cards">
//                   <div className="financial-card">
//                     <label>Total Earnings</label>
//                     <p className="earning">{formatCurrency(viewingBus.summary?.totalEarnings)}</p>
//                   </div>
//                   <div className="financial-card">
//                     <label>Total Commission</label>
//                     <p className="commission">{formatCurrency(viewingBus.summary?.totalCommission)}</p>
//                   </div>
//                   <div className="financial-card">
//                     <label>Net Profit</label>
//                     <p className="profit">{formatCurrency(viewingBus.summary?.netIncome)}</p>
//                   </div>
//                   <div className="financial-card">
//                     <label>Total Bookings</label>
//                     <p>{viewingBus.summary?.totalBookings || 0}</p>
//                   </div>
//                   <div className="financial-card">
//                     <label>Seats Sold</label>
//                     <p>{viewingBus.summary?.totalSeatsSold || 0}</p>
//                   </div>
//                   <div className="financial-card">
//                     <label>Occupancy Rate</label>
//                     <p>{viewingBus.summary?.occupancyRate || 0}%</p>
//                   </div>
//                 </div>
//               </div>

//               {/* Daily Breakdown */}
//               {viewingBus.dailyBreakdown && viewingBus.dailyBreakdown.length > 0 && (
//                 <div className="detail-section">
//                   <h4>Daily Breakdown</h4>
//                   <div className="daily-breakdown-table">
//                     <table className="mini-table">
//                       <thead>
//                         <tr>
//                           <th>Date</th>
//                           <th>Earnings</th>
//                           <th>Bookings</th>
//                           <th>Seats Sold</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {viewingBus.dailyBreakdown.map((day, idx) => (
//                           <tr key={idx}>
//                             <td>{day.date}</td>
//                             <td>{formatCurrency(day.earnings)}</td>
//                             <td>{day.bookings}</td>
//                             <td>{day.seatsSold}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               )}

//               {/* Recent Bookings */}
//               {viewingBus.bookings && viewingBus.bookings.length > 0 && (
//                 <div className="detail-section">
//                   <h4>Recent Bookings</h4>
//                   <div className="bookings-list">
//                     <table className="mini-table">
//                       <thead>
//                         <tr>
//                           <th>PNR</th>
//                           <th>Date</th>
//                           <th>Seats</th>
//                           <th>Amount</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {viewingBus.bookings.slice(0, 5).map((booking, idx) => (
//                           <tr key={idx}>
//                             <td>{booking.pnr}</td>
//                             <td>{new Date(booking.journeyDate).toLocaleDateString()}</td>
//                             <td>{booking.seatsBooked}</td>
//                             <td>{formatCurrency(booking.amount)}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                     {viewingBus.bookings.length > 5 && (
//                       <p style={{ textAlign: 'center', marginTop: '10px', color: '#666' }}>
//                         +{viewingBus.bookings.length - 5} more bookings
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ProfitReport;

import React, { useState, useEffect } from 'react';
import { getAllBusesIncome, getBusIncome, getBusIncomeSummary } from '../../Services/Operations/ProductAPI';
import '../../Styles/ManagementPages.css';
import { useSelector } from 'react-redux';

// Skeleton Components
const SkeletonStatsCard = () => (
  <div className="stat-card skeleton">
    <div className="skeleton-title"></div>
    <div className="skeleton-value"></div>
    <div className="skeleton-subtitle"></div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-actions"></div></td>
  </tr>
);

const SkeletonTable = () => (
  <div className="table-container skeleton">
    <table className="data-table">
      <thead>
        <tr>
          <th>Bus Number</th>
          <th>Bus Name</th>
          <th>Bus Type</th>
          <th>Owner</th>
          <th>Bookings</th>
          <th>Seats Sold</th>
          <th>Earnings</th>
          <th>Commission</th>
          <th>Net Profit</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
          <SkeletonTableRow key={i} />
        ))}
      </tbody>
    </table>
  </div>
);

const SkeletonModal = () => (
  <div className="modal-overlay">
    <div className="modal-content1 skeleton-modal" style={{ maxWidth: '800px' }}>
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        <div className="detail-section">
          <div className="skeleton-section-title"></div>
          <div className="detail-grid">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="skeleton-detail-row">
                <div className="skeleton-label"></div>
                <div className="skeleton-value"></div>
              </div>
            ))}
          </div>
        </div>
        <div className="detail-section">
          <div className="skeleton-section-title"></div>
          <div className="financial-cards">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="financial-card skeleton">
                <div className="skeleton-label"></div>
                <div className="skeleton-value"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const ProfitReport = () => {
  const [profitData, setProfitData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searching, setSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [viewingBus, setViewingBus] = useState(null);
  const [error, setError] = useState(null);
  const { token } = useSelector(state => state.user);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [pageSize] = useState(10);

  // Filter states
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    busType: '',
    busCategory: '',
    ownerId: '',
    minEarnings: '',
    maxEarnings: ''
  });
  const [showFilters, setShowFilters] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);
  
  // Sorting states
  const [sortBy, setSortBy] = useState('totalEarnings');
  const [sortOrder, setSortOrder] = useState('desc');

  // Fetch all buses profit data
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchAllBusesProfit();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [currentPage, searchTerm, filters, sortBy, sortOrder]);

  const fetchAllBusesProfit = async () => {
    try {
      setSearching(true);
      setLoading(true);
      setError(null);
      
      // Prepare filter parameters
      const filterParams = {};
      
      if (searchTerm) {
        filterParams.search = searchTerm;
      }
      
      // Add other filters
      Object.keys(filters).forEach(key => {
        if (filters[key] && filters[key] !== '') {
          filterParams[key] = filters[key];
        }
      });

      // Add pagination and sorting
      const params = {
        page: currentPage,
        limit: pageSize,
        sortBy: sortBy,
        sortOrder: sortOrder,
        ...filterParams
      };

      console.log('Fetching profit data with params:', params);

      const response = await getAllBusesIncome(params, token);
      
      if (response && response.success) {
        console.log('Profit data response:', response);
        
        setProfitData(response.data.buses || []);
        setSummary(response.data.summary);
        setTotalPages(response.data.pagination?.totalPages || 1);
        setTotalItems(response.data.pagination?.totalItems || 0);
        
        // Check if any filter is active
        const hasActiveFilters = 
          searchTerm !== '' || 
          Object.values(filters).some(value => value && value !== '');
        setIsFiltered(hasActiveFilters);
      } else {
        setError('Failed to fetch profit data.');
        setProfitData([]);
      }
    } catch (err) {
      console.error('Error fetching profit data:', err);
      setError('Failed to fetch profit data. Please try again.');
      setProfitData([]);
    } finally {
      setLoading(false);
      setSearching(false);
    }
  };

  // Fetch single bus details
  const handleViewBusDetails = async (bus) => {
    try {
      setLoading(true);
      const params = {};
      
      if (filters.startDate) params.startDate = filters.startDate;
      if (filters.endDate) params.endDate = filters.endDate;
      
      const response = await getBusIncome(bus.bus.id, params, token);
      
      if (response && response.success) {
        setViewingBus(response.data);
      } else {
        alert('Failed to fetch bus details');
      }
    } catch (error) {
      console.error('Error fetching bus details:', error);
      alert('Error fetching bus details: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  // Filter handlers
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchAllBusesProfit();
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const applyFilters = () => {
    setCurrentPage(1);
    fetchAllBusesProfit();
    setShowFilters(false);
  };

  const clearFilters = () => {
    setFilters({
      startDate: '',
      endDate: '',
      busType: '',
      busCategory: '',
      ownerId: '',
      minEarnings: '',
      maxEarnings: ''
    });
    setSearchTerm('');
    setCurrentPage(1);
    setIsFiltered(false);
  };

  // Sort handler
  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(field);
      setSortOrder('desc');
    }
    setCurrentPage(1);
  };

  // Export CSV function
  const handleExportReport = () => {
    if (profitData.length === 0) {
      alert('No data to export');
      return;
    }

    const headers = [
      'Bus Number', 
      'Bus Name', 
      'Bus Type', 
      'Owner Name', 
      'Total Bookings', 
      'Total Seats Sold', 
      'Total Earnings (₹)', 
      'Commission (₹)', 
      'Net Income (₹)',
      'Avg Ticket Price (₹)'
    ];
    
    const csvData = profitData.map(item => [
      item.bus.busNumber || '',
      item.bus.busName || '',
      item.bus.busType || '',
      item.owner.name || '',
      item.stats.totalBookings || 0,
      item.stats.totalSeatsSold || 0,
      item.stats.totalEarnings || 0,
      item.stats.totalCommission || 0,
      item.stats.netIncome || 0,
      item.stats.averageTicketPrice || 0
    ]);

    const csvContent = [
      headers.join(','),
      ...csvData.map(row => row.map(field => `"${field}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `profit-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    alert('Profit report exported successfully!');
  };

  const closeViewModal = () => {
    setViewingBus(null);
  };

  const handleRefresh = () => {
    setSearchTerm('');
    setCurrentPage(1);
    clearFilters();
    fetchAllBusesProfit();
  };

  // Pagination handlers
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Format currency
  const formatCurrency = (amount) => {
    return `₹${(amount || 0).toLocaleString()}`;
  };

  // Get bus type badge class
  const getBusTypeBadge = (busType) => {
    const type = (busType || '').toLowerCase();
    if (type === 'ac') return 'bus-type-ac';
    if (type === 'non-ac') return 'bus-type-non-ac';
    return 'bus-type-standard';
  };

  // Generate page numbers
  const generatePageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let start = Math.max(1, currentPage - 2);
      let end = Math.min(totalPages, start + maxVisiblePages - 1);
      
      if (end - start + 1 < maxVisiblePages) {
        start = Math.max(1, end - maxVisiblePages + 1);
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }
    
    return pages;
  };

  // Loading state with skeletons
  if (loading && profitData.length === 0) {
    return (
      <div className="management-page">
        <div className="page-header">
          <div className="skeleton-header-title"></div>
          <div className="header-actions">
            <div className="skeleton-search"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="stats-cards">
          {[1, 2, 3, 4, 5].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>

        <SkeletonTable />

        <div className="pagination-container">
          <div className="skeleton-pagination-info"></div>
          <div className="skeleton-pagination-controls"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="management-page">
      <div className="page-header">
        <h1>Profit Report</h1>
        <div className="header-actions">
          <form onSubmit={handleSearchSubmit} className="search-form">
            <div style={{ position: 'relative' }}>
              <input 
                type="text" 
                placeholder="Search by bus number, name or owner..." 
                className="search-input" 
                value={searchTerm}
                onChange={handleSearchChange}
                style={{ width: "70%" }}
              />
              {searching && (
                <span style={{
                  position: 'absolute', right: '10px', top: '50%',
                  transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
                }}>
                  searching...
                </span>
              )}
            </div>
          </form>
          
          <button className="filter-toggle-btn" onClick={() => setShowFilters(!showFilters)}>
            {showFilters ? 'Hide Filters' : 'Show Filters'}
          </button>
          <button className="refresh-btn" onClick={handleRefresh}>
            Refresh
          </button>
          <button className="export-btn" onClick={handleExportReport}>
            Export Report
          </button>
        </div>
      </div>

      {/* Filter Panel */}
      {showFilters && (
        <div className="filter-panel">
          <div className="filter-header">
            <h3>Filter Profit Report</h3>
            <button className="close-filters" onClick={() => setShowFilters(false)}>
              ×
            </button>
          </div>
          <div className="filter-grid">
            <div className="filter-group">
              <label>Date From</label>
              <input
                type="date"
                name="startDate"
                value={filters.startDate}
                onChange={handleFilterChange}
              />
            </div>
            <div className="filter-group">
              <label>Date To</label>
              <input
                type="date"
                name="endDate"
                value={filters.endDate}
                onChange={handleFilterChange}
              />
            </div>
            <div className="filter-group">
              <label>Bus Type</label>
              <select
                name="busType"
                value={filters.busType}
                onChange={handleFilterChange}
              >
                <option value="">All Types</option>
                <option value="AC">AC</option>
                <option value="Non-AC">Non-AC</option>
              </select>
            </div>
            <div className="filter-group">
              <label>Bus Category</label>
              <select
                name="busCategory"
                value={filters.busCategory}
                onChange={handleFilterChange}
              >
                <option value="">All Categories</option>
                <option value="sleeper">Sleeper</option>
                <option value="seater">Seater</option>
                <option value="semi-sleeper">Semi-Sleeper</option>
              </select>
            </div>
            <div className="filter-group">
              <label>Min Earnings (₹)</label>
              <input
                type="number"
                name="minEarnings"
                value={filters.minEarnings}
                onChange={handleFilterChange}
                placeholder="Minimum earnings"
                min="0"
              />
            </div>
            <div className="filter-group">
              <label>Max Earnings (₹)</label>
              <input
                type="number"
                name="maxEarnings"
                value={filters.maxEarnings}
                onChange={handleFilterChange}
                placeholder="Maximum earnings"
                min="0"
              />
            </div>
          </div>
          <div className="filter-actions">
            <button className="apply-filters-btn" onClick={applyFilters}>
              Apply Filters
            </button>
            <button className="clear-filters-btn" onClick={clearFilters}>
              Clear All
            </button>
          </div>
          {isFiltered && (
            <div className="active-filters">
              <span>Active Filters:</span>
              {searchTerm && (
                <span className="filter-tag">Search: {searchTerm}</span>
              )}
              {filters.busType && (
                <span className="filter-tag">Type: {filters.busType}</span>
              )}
              {filters.busCategory && (
                <span className="filter-tag">Category: {filters.busCategory}</span>
              )}
              {filters.startDate && (
                <span className="filter-tag">From: {filters.startDate}</span>
              )}
              {filters.endDate && (
                <span className="filter-tag">To: {filters.endDate}</span>
              )}
              {filters.minEarnings && (
                <span className="filter-tag">Min: ₹{filters.minEarnings}</span>
              )}
              {filters.maxEarnings && (
                <span className="filter-tag">Max: ₹{filters.maxEarnings}</span>
              )}
            </div>
          )}
        </div>
      )}

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      {/* Summary Stats Cards */}
      {summary && (
        <div className="stats-cards">
          <div className="stat-card">
            <h3>Total Earnings</h3>
            <p>{formatCurrency(summary.totalEarnings)}</p>
            <span>Gross revenue</span>
          </div>
          <div className="stat-card">
            <h3>Total Commission</h3>
            <p>{formatCurrency(summary.totalCommission)}</p>
            <span>Paid to owners</span>
          </div>
          <div className="stat-card">
            <h3>Net Profit</h3>
            <p>{formatCurrency(summary.totalNetIncome)}</p>
            <span>After commission</span>
          </div>
          <div className="stat-card">
            <h3>Total Bookings</h3>
            <p>{summary.totalBookings || 0}</p>
            <span>Confirmed bookings</span>
          </div>
          <div className="stat-card">
            <h3>Seats Sold</h3>
            <p>{summary.totalSeatsSold || 0}</p>
            <span>Total seats</span>
          </div>
        </div>
      )}

      {/* Loading indicator for table while fetching but not initial load */}
      {loading && profitData.length > 0 && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <span>Updating data...</span>
        </div>
      )}

      {/* Profit Table */}
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th onClick={() => handleSort('busNumber')} style={{ cursor: 'pointer' }}>
                Bus Number {sortBy === 'busNumber' && (sortOrder === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('busName')} style={{ cursor: 'pointer' }}>
                Bus Name {sortBy === 'busName' && (sortOrder === 'asc' ? '↑' : '↓')}
              </th>
              <th>Bus Type</th>
              <th onClick={() => handleSort('ownerName')} style={{ cursor: 'pointer' }}>
                Owner {sortBy === 'ownerName' && (sortOrder === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('totalBookings')} style={{ cursor: 'pointer' }}>
                Bookings {sortBy === 'totalBookings' && (sortOrder === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('totalSeatsSold')} style={{ cursor: 'pointer' }}>
                Seats Sold {sortBy === 'totalSeatsSold' && (sortOrder === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('totalEarnings')} style={{ cursor: 'pointer' }}>
                Earnings {sortBy === 'totalEarnings' && (sortOrder === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('totalCommission')} style={{ cursor: 'pointer' }}>
                Commission {sortBy === 'totalCommission' && (sortOrder === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('netIncome')} style={{ cursor: 'pointer' }}>
                Net Profit {sortBy === 'netIncome' && (sortOrder === 'asc' ? '↑' : '↓')}
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {profitData.length > 0 ? (
              profitData.map((item, index) => (
                <tr key={item.bus.id || index}>
                  <td className="transaction">{item.bus.busNumber || 'N/A'}</td>
                  <td>{item.bus.busName || 'N/A'}</td>
                  <td>
                    <span className={`bus-type-badge ${getBusTypeBadge(item.bus.busType)}`}>
                      {item.bus.busType || 'Standard'}
                    </span>
                  </td>
                  <td>
                    <div>
                      <div>{item.owner.name || 'N/A'}</div>
                      <div className="phone">{item.owner.phone || ''}</div>
                    </div>
                  </td>
                  <td>{item.stats.totalBookings || 0}</td>
                  <td>{item.stats.totalSeatsSold || 0}</td>
                  <td className="earning">{formatCurrency(item.stats.totalEarnings)}</td>
                  <td className="commission">{formatCurrency(item.stats.totalCommission)}</td>
                  <td className="profit">{formatCurrency(item.stats.netIncome)}</td>
                  <td>
                    <div className="action-buttons">
                      <button 
                        className="action-btn view" 
                        onClick={() => handleViewBusDetails(item)}
                        disabled={loading}
                      >
                        {loading ? 'Loading...' : 'View Details'}
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="no-data">
                  <p>No profit data found {isFiltered ? 'matching your filters' : ''}.</p>
                  {isFiltered && (
                    <button className="clear-filters-link" onClick={clearFilters}>
                      Clear filters to see all data
                    </button>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination-container">
          <div className="pagination-info">
            Showing {profitData.length} of {totalItems} buses
            (Page {currentPage} of {totalPages})
            {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
            {isFiltered && !searchTerm && <span className="filtered-indicator"> • Filtered Results</span>}
          </div>
          <div className="pagination-controls">
            <button 
              className="pagination-btn" 
              onClick={handlePrevPage}
              disabled={currentPage === 1 || loading}
            >
              Previous
            </button>
            
            <div className="page-numbers">
              {generatePageNumbers().map(pageNumber => (
                <button
                  key={pageNumber}
                  className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
                  onClick={() => handlePageClick(pageNumber)}
                  disabled={loading}
                >
                  {pageNumber}
                </button>
              ))}
              
              {totalPages > 5 && currentPage < totalPages - 2 && (
                <>
                  <span className="page-dots">...</span>
                  <button
                    className="page-number"
                    onClick={() => handlePageClick(totalPages)}
                    disabled={loading}
                  >
                    {totalPages}
                  </button>
                </>
              )}
            </div>
            
            <button 
              className="pagination-btn" 
              onClick={handleNextPage}
              disabled={currentPage === totalPages || loading}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {/* Bus Details Modal */}
      {viewingBus && !loading && (
        <div className="modal-overlay" onClick={closeViewModal}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px' }}>
            <div className="modal-header">
              <h3>Bus Profit Details - {viewingBus.bus?.busNumber}</h3>
              <button className="modal-close-btn" onClick={closeViewModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              {/* Bus Information */}
              <div className="detail-section">
                <h4>Bus Information</h4>
                <div className="detail-grid">
                  <div className="detail-row">
                    <label>Bus Number:</label>
                    <span>{viewingBus.bus?.busNumber || 'N/A'}</span>
                  </div>
                  <div className="detail-row">
                    <label>Bus Name:</label>
                    <span>{viewingBus.bus?.busName || 'N/A'}</span>
                  </div>
                  <div className="detail-row">
                    <label>Bus Type:</label>
                    <span>{viewingBus.bus?.busType || 'N/A'}</span>
                  </div>
                  <div className="detail-row">
                    <label>Total Seats:</label>
                    <span>{viewingBus.bus?.totalSeats || 'N/A'}</span>
                  </div>
                </div>
              </div>

              {/* Owner Information */}
              <div className="detail-section">
                <h4>Owner Information</h4>
                <div className="detail-grid">
                  <div className="detail-row">
                    <label>Owner Name:</label>
                    <span>{viewingBus.owner?.name || 'N/A'}</span>
                  </div>
                  <div className="detail-row">
                    <label>Company:</label>
                    <span>{viewingBus.owner?.companyName || 'N/A'}</span>
                  </div>
                  <div className="detail-row">
                    <label>Email:</label>
                    <span>{viewingBus.owner?.email || 'N/A'}</span>
                  </div>
                  <div className="detail-row">
                    <label>Phone:</label>
                    <span>{viewingBus.owner?.phone || 'N/A'}</span>
                  </div>
                  <div className="detail-row">
                    <label>Commission Rate:</label>
                    <span>{viewingBus.owner?.commissionRate || 10}%</span>
                  </div>
                </div>
              </div>

              {/* Financial Summary */}
              <div className="detail-section">
                <h4>Financial Summary</h4>
                <div className="financial-cards">
                  <div className="financial-card">
                    <label>Total Earnings</label>
                    <p className="earning">{formatCurrency(viewingBus.summary?.totalEarnings)}</p>
                  </div>
                  <div className="financial-card">
                    <label>Total Commission</label>
                    <p className="commission">{formatCurrency(viewingBus.summary?.totalCommission)}</p>
                  </div>
                  <div className="financial-card">
                    <label>Net Profit</label>
                    <p className="profit">{formatCurrency(viewingBus.summary?.netIncome)}</p>
                  </div>
                  <div className="financial-card">
                    <label>Total Bookings</label>
                    <p>{viewingBus.summary?.totalBookings || 0}</p>
                  </div>
                  <div className="financial-card">
                    <label>Seats Sold</label>
                    <p>{viewingBus.summary?.totalSeatsSold || 0}</p>
                  </div>
                  <div className="financial-card">
                    <label>Occupancy Rate</label>
                    <p>{viewingBus.summary?.occupancyRate || 0}%</p>
                  </div>
                </div>
              </div>

              {/* Daily Breakdown */}
              {viewingBus.dailyBreakdown && viewingBus.dailyBreakdown.length > 0 && (
                <div className="detail-section">
                  <h4>Daily Breakdown</h4>
                  <div className="daily-breakdown-table">
                    <table className="mini-table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Earnings</th>
                          <th>Bookings</th>
                          <th>Seats Sold</th>
                        </tr>
                      </thead>
                      <tbody>
                        {viewingBus.dailyBreakdown.map((day, idx) => (
                          <tr key={idx}>
                            <td>{day.date}</td>
                            <td>{formatCurrency(day.earnings)}</td>
                            <td>{day.bookings}</td>
                            <td>{day.seatsSold}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Recent Bookings */}
              {viewingBus.bookings && viewingBus.bookings.length > 0 && (
                <div className="detail-section">
                  <h4>Recent Bookings</h4>
                  <div className="bookings-list">
                    <table className="mini-table">
                      <thead>
                        <tr>
                          <th>PNR</th>
                          <th>Date</th>
                          <th>Seats</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {viewingBus.bookings.slice(0, 5).map((booking, idx) => (
                          <tr key={idx}>
                            <td>{booking.pnr}</td>
                            <td>{new Date(booking.journeyDate).toLocaleDateString()}</td>
                            <td>{booking.seatsBooked}</td>
                            <td>{formatCurrency(booking.amount)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {viewingBus.bookings.length > 5 && (
                      <p style={{ textAlign: 'center', marginTop: '10px', color: '#666' }}>
                        +{viewingBus.bookings.length - 5} more bookings
                      </p>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="modal-close-btn secondary" onClick={closeViewModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading state for modal */}
      {viewingBus && loading && <SkeletonModal />}
    </div>
  );
};

export default ProfitReport;